import React, { useEffect, useState } from "react";
import ReviewTable from "./ReviewTable";
import {
  TABLE_HEADERS_REVIEW_MANAGEMENT as TABLE_HEADERS,
  SEARCH_CONFIG_REVIEW_MANAGEMENT as SEARCH_CONFIG,
} from "../../data/TableData";
import { fetchReviewManagementInfo } from "../../requests";
import { useDispatch } from "react-redux";
import useDebounce from "../hooks/useDebounce";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { deleteAuthToken } from "../../utils/helper";
import _ from "lodash";

function Index() {
  const [filter, setFilter] = useState({
    column: "",
    value: "",
  });
  const [searchValue, setSearchValue] = useState("");
  const [sort, setSort] = useState({
    column: "id",
    order: "DESC",
  });
  const [data, setData] = useState({
    headers: TABLE_HEADERS,
    rows: [],
    paginationData: {},
  });
  const [dateFilter, setDateFilter] = useState({
    startDate: "",
    endDate: "",
  });
  const [page, setPage] = useState(1);

  const debouncedSearchValue = useDebounce(searchValue, 300);
  const dispatch = useDispatch();

  useEffect(() => {
    handleReviewManagementInfo();
  }, [filter, sort, dateFilter, page]);

  useEffect(() => {
    if (debouncedSearchValue !== undefined) {
      handleReviewManagementInfo();
    }
  }, [debouncedSearchValue]);

  const handleReviewManagementInfo = async () => {
    dispatch(startLoader());
    try {
      const requestData = {
        page: page,
        limit: 25,
        filter_column: filter.column,
        filter_value: filter.value,
        sort_by: sort.column,
        sort_order: sort.order,
        start_date: dateFilter.startDate,
        end_date: dateFilter.endDate,
        search: debouncedSearchValue,
      };

      const response = await fetchReviewManagementInfo(requestData);
      const rows = response.data.reviews;
      const paginationData = response.data.pagination;

  

      setData({
        headers: TABLE_HEADERS,
        rows: rows || [],
        paginationData: paginationData || {},
      });
    } catch (error) {
      if (error?.response?.status === 401) {
        deleteAuthToken();
        window.location.reload();
      }
      console.error("Error in sending message:", error);
    }

    dispatch(stopLoader());
  };

  const handleFilterChange = (column, filter) => {
    if (["active", "expired"].includes(_.lowerCase(filter.value))) {
      setFilter({ column: "sub_end", value: filter.value });
    } else if (
      ["premium", "basic", "free"].includes(_.lowerCase(filter.value))
    ) {
      setFilter({ column: "sub_type", value: filter.value });
    } else if (["english", "arabic"].includes(_.lowerCase(filter.value))) {
      setFilter({ column: "language", value: filter.value });
    } else {
      setFilter({ column: column, value: filter.value });
    }
  };

  const handleSearchChange = (value) => {
    setSearchValue(value);
  };

  const handleSorting = (sort) => {
    if (sort.value === "Name ASC") {
      setSort({ column: "full_name", order: "ASC" });
    } else if (sort.value === "Name DESC") {
      setSort({ column: "full_name", order: "DESC" });
    } else if (sort.value === "Session ASC") {
      setSort({ column: "session_title", order: "ASC" });
    } else if (sort.value === "Session DESC") {
      setSort({ column: "session_title", order: "DESC" });
    }
  };
  const handleDateFilterChange = (date) => {
    if (date.startDate && date.endDate) {
      setDateFilter({ startDate: date.startDate, endDate: date.endDate });
    }
  };

  const handlePageChange = (newPage, limit = 25) => {
    setPage(newPage);
  };

  return (
    <ReviewTable
      headers={data.headers}
      rows={data.rows}
      handleFilterChange={handleFilterChange}
      handleSearchChange={handleSearchChange}
      searchValue={searchValue}
      handleSorting={handleSorting}
      handleDateFilterChange={handleDateFilterChange}
      onPageChange={handlePageChange}
      pagination={data.paginationData}
      searchConfig={SEARCH_CONFIG}
      refreshTable={handleReviewManagementInfo}
      variant="blue"
    />
  );
}

export default Index;
